enum Actions {
  GET_REMOTEHOST = "getRemoteHost",
  CHECK_USER_AUTH_STATE = "checkUserAuthState",
  LOGIN = "login",
  LOGOUT = "logout",
  VALIDATE_SESSION = "validateSession",
  USER_INFO = "userInfo",
  USER_AUTH_STATE = "userAuthState",
  CHANGE_USER_PASSWORD = "changeUserPassword",
  GET_USER_DOCUMENT = "getUserDocument",
  GET_USER_REGISTER_POINTS = "getUserRegisterPoints",
  REGISTER_NEW_READING = "registerNewReading",
  GET_REF_USER_GROUPS = "getRefUserGroups",
  GET_REF_RECORD_STASUSES = "getRefRecordStatuses",
  GET_REF_DEPARTMENTS = "getRefDepartments",
  GET_USERS = "getUsers",
  GET_USER = "getUser",
  UPDATE_USER = "updateUser",
  GET_REF_SUBSCRIBERS = "getRefSubscribers",
  GET_REF_SUBSCRIBER = "getRefSubscriber",
  UPDATE_REF_SUBSCRIBER = "updateRefSubscriber",
  RESET_REF_SUBSCRIBER_LASTRRQS = "ResetRefSubscriberLastRRQS",
}

enum Mutations {
  // mutation types
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_ERROR = "setError",
  SET_VALIDATED_USER = "setValidatedUser",
  CLEAR_ERROR = "clearError",
  SET_SUBSCRIBER_DATA = "setSubscriberData",
  PURGE_SUBSCRIBER_DATA = "purgeSubscriberData",
  SET_OPERATOR_DATA = "setOperatorData",
  PURGE_OPERATOR_DATA = "purgeOperatorData"
}

export { Actions, Mutations };
